<template>
    <div class="recently_lou_plus">
        <ul class="recently_lou_plus_nav_ul">
            <li class="recently_lou_plus_nav_li">
                <a class="recently_lou_plus_nav_a">
                    相关路径
                </a>
            </li>
        </ul>
        <ul class="recently_lou_plus_ul">
            <li v-for="(path, index) in related_paths"
                :key="index"
                class="recently_lou_plus_li"
            >
                <a :href="'/path/'+path.id"
                             class="recently_lou_plus_a"
                >
                    <span class="lou_plus_title">
                        {{ path.name }}
                    </span>
                    <!--<span class="lou_plus_date">-->
                    <!--{{ trans_date(path.open_time) }}-->
                    <!--</span>-->
                </a>
            </li>
        </ul>
    </div>
</template>
<script type="text/javascript">
    import {mapState} from 'vuex'
    import PathApi from '@/api/path/path.js'

    export default {
        data() {
            return {
                related_paths: []
            }
        },
        computed: {
            ...mapState({
                recently_louplus: state => state.path.course_path_information.recently_louplus
            })
        },
        methods: {
            trans_date: function (time) {
                let date = new Date(time)
                let m = date.getMonth() + 1
                let d = date.getDate()
                m = m.toString()
                d = d.toString()
                m = m.padStart(2, '0')
                d = d.padStart(2, '0')

                return `${m}月${d}日`
            }
        },
        mounted() {
            PathApi.get_path_information().then((res) => {
                console.log(123)
                let p_id = this.$route.params.id
                this.related_paths = res.data.results
                let index
                for (let i = 0; i < this.related_paths.length; i++) {
                    if (this.related_paths[i].id == p_id) {
                        index = i
                        break
                    }
                }
                this.related_paths.splice(index, 1)

            })
        },
    }

</script>
<style type="text/css" scoped>
    .recently_lou_plus {
        background: #fff;
        margin-left: 10px;
        margin-bottom: 10px;
        padding: 15px;
    }

    .recently_lou_plus_nav_ul {
        margin-bottom: 10px;
        border: none;
        border-bottom: 1px solid #eee;
        display: flex;
    }

    .recently_lou_plus_nav_li {

    }

    .recently_lou_plus_nav_a {
        display: block;
        padding: 0 0 4px;
        margin: 0 48px 0 0;
        font-size: 16px;
        color: #4c5157;
        background: transparent;
        border: none;
        border-bottom: 1px solid transparent;
    }

    .recently_lou_plus_li {
        font-size: 14px;
    }

    /*.recently_lou_plus_li:hover {
        background: #f5f5f5;
    }*/

    .recently_lou_plus_a {

        display: flex;
        padding: 10px 0;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        color: #4c5157;
    }

    .lou_plus_title {
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lou_plus_date {
        color: orange;
    }

    /*.recently_lou_plus_a:hover {
        color: #4c5157;
        background: #f5f5f5;
    }*/
</style>
